import { Injectable, OnInit } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';







@Injectable({ providedIn: 'root' })
export class CustomHttpInterceptorInterceptor implements HttpInterceptor
{

  lang =  'en';

  constructor(
    private cookie_s: CookieService,

  ) {}

  intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>>
  {


    // user token
    let user_token = '';

    if ( this.cookie_s.get('user') )
    {
      user_token = JSON.parse( this.cookie_s.get('user') ).token;
    }
    else
    {
      user_token = '';
    }

    let temp = localStorage.getItem('active_lang');
    this.lang= temp ? JSON.parse(temp).code : 'ar';

    // set site language



    // language api does not need anything (headers)
    if (
      request.url.startsWith(`${environment.ApiEndPoint2}/lang/langs`)
    )
    {

      request = request.clone({
        headers: request.headers
          .set('vendor_code', environment.vendor_code)
          .set('vendor_id', environment.vendor_id)
      });

    }
    else if (
      request.url.startsWith(environment.ApiEndPoint) ||
      request.url.startsWith(environment.ApiEndPoint2) ||
      request.url.startsWith(environment.graphqlendpoint) ||
      request.url.startsWith(environment.PaymentApiEndPoint)||
      request.url.startsWith(environment.PaymentApiEndPointGraphql)


    )
    {

      if (user_token != '')
      {
        request = request.clone({
          headers: request.headers
            .set('Authorization', 'Bearer ' + user_token)
            .set('lang', this.lang)
            .set('vendor_code', environment.vendor_code)
            .set('vendor_id', environment.vendor_id)
        });

      }
      else
      {

        request = request.clone({
          headers: request.headers
          .set('lang',  this.lang)
          .set('vendor_code', environment.vendor_code)
          .set('vendor_id', environment.vendor_id)
        });
      }

    }



    return next.handle(request);


  }




}
